export default __webpack_public_path__ + "static/media/transfacil_galery_4.92f7b0e9.jpg";